export default{
  namespaced: true,
  state: {
    popupData: 'default'
  },
  mutations: {
    SET_POPUP(state: State, popupData: string): void {
      state.popupData = popupData;
    }
  }
} 
interface State {
  popupData: string;
}
